import { Control, Controller } from 'react-hook-form';
import { PhoneInput, PhoneInputProps } from '@aqarmap/aqarmap-ui';
import '@aqarmap/aqarmap-ui/phoneInput.css';
export default function PhoneInputController({
  control,
  field,
  ...restProps
}: PhoneInputProps & { control: Control<any> }) {
  return (
    <Controller
      control={control}
      name={field.name ?? ''}
      render={({
        //eslint-disable-next-line @typescript-eslint/no-unused-vars
        field: { onChange, ref, value, ...controlFieldRest },
        fieldState: { error },
      }) => (
        <PhoneInput
          className="b-0"
          field={{
            ...controlFieldRest,
            ...field,
            value,
          }}
          onChange={onChange}
          error={error?.message}
          {...restProps}
        />
      )}
    />
  );
}
